import {ITranslationParams, TBaseOrObservableOrFunctionType} from "../../index";

export type IDropdownLabel = (() => string | ITranslationParams | null) | string | ITranslationParams | null

export interface IDropdownButtonChrome {
    attributes?: Record<string, string | number | null | undefined>
    cls?: string
    description?: () => string
    enabled?: () => boolean
    icon?: TBaseOrObservableOrFunctionType<string> | undefined
    validator?: () => boolean | null | undefined
}

export type IDropdownButton =
    | (IDropdownButtonChrome & {
          label: IDropdownLabel
          onClick: () => void
          href?: undefined
          target?: undefined
      })
    | (IDropdownButtonChrome & {
          label: IDropdownLabel
          href: () => string
          onClick?: undefined
          target?: string
      })
